import React from "react";
import { Space } from "@masterteam/mt-design-react";
import useIsAr from "../../../../Hooks/useIsAr";

import styles from "./StrategyPlus.module.scss";

function StrategyPlus() {
  const [isAr] = useIsAr();

  return (
    <div className={styles.leftSide}>
      <div className={styles.content}>
        <Space direction="vertical" size="medium">
          <h1 className="txt_sup_login">
            {window.env?.[isAr ? "SLOGAN_AR" : "SLOGAN"]}
          </h1>
          <h3 className="">
            {window.env?.[isAr ? "SLOGAN_SUB_AR" : "SLOGAN_SUB"]}
          </h3>
        </Space>

        <small style={{ justifyContent: "flex-end" }}>
          {window.env.COPYRIGHT || (
            <span>
              {isAr ? "جميع الحقوق محفوظة" : "SPlus All Rights Reserved"}
            </span>
          )}
          {` ${new Date().getFullYear()} SPlus ©`}
        </small>
      </div>
    </div>
  );
}

export default StrategyPlus;
